import { INodeTemplate } from '@/types/node';
import { Box, Button, Icon, IconButton } from '@mui/material';
import React, { useRef } from 'react';

export interface NodeTarget {
  target: HTMLElement;
  id: string;
  template: INodeTemplate;
}

const useStyles = () => ({
  root: {
    position: 'absolute !important',
  },
  corner: {
    position: 'absolute !important',
    top: 0,
    left: 0,
  },
  line: {
    backgroundColor: '#f00 !important',
    position: 'absolute !important',
  },
  button: {
    fontFamily: 'Helvetica, Arial, sans-serif !important',
    padding: '2px 8px !important',
    fontSize: '0.7rem !important',
    color: 'white !important',
    backgroundColor: '#f00 !important',
    position: 'absolute !important',
    zIndex: '10000 !important',
    '&:hover': {
      backgroundColor: '#c00 !important',
    },
  },
  deleteButton: {
    color: 'white !important',
    backgroundColor: '#f00 !important',
    position: 'absolute !important',
    zIndex: '10000 !important',
    borderRadius: '0 !important',
    padding: 1,
    width: '30px !important',
    '&:hover': {
      backgroundColor: '#c00 !important',
    },
  },
  addButtonHolder: {
    position: 'absolute !important',
    height: '30px !important',
    display: 'flex',
    alignItems: 'center !important',
    justifyContent: 'center !important',
    zIndex: '10000 !important',
  },
  addButton: {
    // position: 'absolute',
    backgroundColor: '#f00 !important',
    color: 'white !important',

    '&:hover': {
      backgroundColor: '#c00 !important',
    },
  },
});

export const NodeEditMarker = ({
  nodeTarget: { target, id, template },
  callback,
}: {
  nodeTarget?: NodeTarget;
  callback?: (id: string, action: string) => void;
}): JSX.Element | null => {
  const classes = useStyles();
  const corderRef = useRef<HTMLDivElement>(null);

  if (!target) {
    return null;
  }

  var viewportOffset = target.getBoundingClientRect();
  // If page is inside scrollable LiveContainer, the offset will be relative to that
  var parentOffset = corderRef.current
    ? corderRef.current.getBoundingClientRect()
    : { top: 0, left: 0 };

  const rect = {
    top: viewportOffset.top - parentOffset.top,
    left: viewportOffset.left - parentOffset.left,
    // top: target.offsetTop + window.scrollY,
    // left: target.offsetLeft + window.scrollX,
    width: target.offsetWidth,
    height: target.offsetHeight,
  };

  return (
    <>
      <Box sx={classes.corner} ref={corderRef}></Box>
      <Button
        sx={classes.button}
        startIcon={<Icon>settings</Icon>}
        size="small"
        variant="contained"
        color="primary"
        style={{
          top: rect.top,
          left: rect.left,
        }}
        onClick={() => {
          console.log('Edit', id);
          callback(id, 'edit');
        }}
      >
        {template?.name}
      </Button>
      {template.supports?.hasOwnProperty('children') && (
        <Box
          sx={classes.addButtonHolder}
          style={{
            top: rect.top + rect.height - 15,
            left: rect.left,
            width: rect.width,
          }}
        >
          <IconButton
            sx={classes.addButton}
            size="small"
            onClick={() => {
              callback(id, 'add');
            }}
          >
            <Icon>add_circle</Icon>
          </IconButton>
        </Box>
      )}
      <IconButton
        sx={classes.deleteButton}
        size="small"
        onClick={() => {
          callback(id, 'delete');
        }}
        style={{
          top: rect.top,
          left: rect.left + rect.width - 30,
        }}
      >
        <Icon>delete</Icon>
      </IconButton>
      <Box
        sx={classes.line}
        style={{
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: 1,
        }}
      />
      <Box
        sx={classes.line}
        style={{
          top: rect.top,
          left: rect.left,
          width: 1,
          height: rect.height,
        }}
      />
      <Box
        sx={classes.line}
        style={{
          top: rect.top,
          left: rect.left + rect.width,
          width: 1,
          height: rect.height,
        }}
      />
      <Box
        sx={classes.line}
        style={{
          top: rect.top + rect.height,
          left: rect.left,
          width: rect.width,
          height: 1,
        }}
      />
    </>
  );
};
NodeEditMarker.displayName = 'NodeEditMarker';
